import React from 'react'
import './footer.css'
import {FaFacebookF, FaGithub} from 'react-icons/fa'
import {FiInstagram} from 'react-icons/fi'



const Footer = () => {
  return (
    <footer>
        <a href="#" className='footer__logo'>Anish Shrestha</a>
        <ul className='permalinks'>
            <li><a href="#">Home</a></li>
            <li><a href="#about">About</a></li>
            <li><a href="#experience">Experience</a></li>
            <li><a href="#portfolio">Portfolio</a></li>
            <li><a href="#contact">Contact</a></li>
        </ul>

        <div className="footer__socials">
            <a href="https://www.facebook.com/vadorsline"><FaFacebookF /></a>
            <a href="https://www.instagram.com/styles_aniswi/"><FiInstagram /></a>
            <a href="https://github.com/stylesaniswi"><FaGithub /></a>
        </div>
        <div className="footer__copyright">
            <small>&copy; Anish Shrestha. All rights reserved</small>
        </div>
    </footer>
  )
}

export default Footer